module.exports = __webpack_public_path__ + "static/pcslogo-9e9bcb2d76c83efee99360c942d0eab5.png";